export const NAV = {
  sidebar: 'nav-sidebar',
  dashboardLink: 'nav-dashboard-link',
  projectsLink: 'nav-projects-link',
  userMenu: 'nav-user-menu',
  notificationBell: 'nav-notification-bell',
  notificationBadge: 'nav-notification-badge',
  notificationItem: 'nav-notification-item',
  notificationMarkAll: 'nav-notification-mark-all',
};

export const PROJECT = {
  createButton: 'project-create-button',
  nameInput: 'project-name-input',
  codeInput: 'project-code-input',
  commodityInput: 'project-commodity-input',
  locationInput: 'project-location-input',
  descriptionInput: 'project-description-input',
  submitButton: 'project-submit-button',
  card: 'project-card',
  openLink: 'project-open-link',
  deleteButton: 'project-delete-button',
  emptyState: 'project-empty-state',
};

export const DRILLHOLE = {
  addButton: 'drillhole-add-button',
  importButton: 'drillhole-import-button',
  csvCollarsInput: 'drillhole-csv-collars-input',
  csvLithoInput: 'drillhole-csv-litho-input',
  csvAssaysInput: 'drillhole-csv-assays-input',
  csvSubmit: 'drillhole-csv-submit',
  holeIdInput: 'drillhole-hole-id-input',
  xInput: 'drillhole-x-input',
  yInput: 'drillhole-y-input',
  zInput: 'drillhole-z-input',
  depthInput: 'drillhole-depth-input',
  azimuthInput: 'drillhole-azimuth-input',
  dipInput: 'drillhole-dip-input',
  submitButton: 'drillhole-submit-button',
  row: 'drillhole-row',
  deleteRow: 'drillhole-delete-row',
  loadDemoButton: 'drillhole-load-demo-button',
  // Import Wizard (Leapfrog-style)
  wizardOpen: 'drillhole-wizard-open',
  wizardStep: 'drillhole-wizard-step',
  wizardCollarInput: 'drillhole-wizard-collar-input',
  wizardSurveyInput: 'drillhole-wizard-survey-input',
  wizardLithoInput: 'drillhole-wizard-litho-input',
  wizardAssayInput: 'drillhole-wizard-assay-input',
  wizardNext: 'drillhole-wizard-next',
  wizardBack: 'drillhole-wizard-back',
  wizardImport: 'drillhole-wizard-import',
  wizardMapSelect: 'drillhole-wizard-map-select', // suffix + fieldKey
  wizardDelimiterSelect: 'drillhole-wizard-delimiter-select',
  wizardOptNormalize: 'drillhole-wizard-opt-normalize',
  wizardOptPadLen: 'drillhole-wizard-opt-pad-len',
  wizardOptTrim: 'drillhole-wizard-opt-trim',
  wizardOptSkipErrors: 'drillhole-wizard-opt-skip-errors',
  wizardDownloadErrors: 'drillhole-wizard-download-errors',
  wizardReport: 'drillhole-wizard-report',
};

export const DASHBOARD = {
  root: 'dashboard-root',
  statProjects: 'dashboard-stat-projects',
  statDrillholes: 'dashboard-stat-drillholes',
  statBlockModels: 'dashboard-stat-block-models',
  statMinePlans: 'dashboard-stat-mine-plans',
};

export const BLOCKMODEL = {
  createButton: 'blockmodel-create-button',
  nameInput: 'blockmodel-name-input',
  blockSizeInput: 'blockmodel-block-size-input',
  cutoffInput: 'blockmodel-cutoff-input',
  submitButton: 'blockmodel-submit-button',
  card: 'blockmodel-card',
  deleteButton: 'blockmodel-delete-button',
  recallButton: 'blockmodel-recall-button',
};

export const MINEPLAN = {
  createButton: 'mineplan-create-button',
  nameInput: 'mineplan-name-input',
  radiusTopInput: 'mineplan-radius-top-input',
  radiusBottomInput: 'mineplan-radius-bottom-input',
  depthInput: 'mineplan-depth-input',
  periodsInput: 'mineplan-periods-input',
  submitButton: 'mineplan-submit-button',
  card: 'mineplan-card',
  deleteButton: 'mineplan-delete-button',
};

export const AI = {
  input: 'ai-input',
  sendButton: 'ai-send-button',
  clearButton: 'ai-clear-button',
  messagesRoot: 'ai-messages-root',
  message: 'ai-message',
};
